<dx-data-grid biz-grid [selection]='{ mode: "single" }' [dataSource]='reportConfigurations' [bizSetSummary]="false" stateStorageKey="reportConfigurations"
    (onRowRemoving)="onRowRemoving($event)" (bizOnToolbarPreparing)="onToolbarPreparing($event)" (onRowDblClick)="onRowDblClick($event)">
    <dxo-editing mode="row" [allowUpdating]="allowUpdating" [allowAdding]="allowAdding" [allowDeleting]="allowDeleting">
        <dxo-texts editRow="Details"></dxo-texts>
    </dxo-editing>

    <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

    <dxi-column caption="Name" dataField="Report.Name" dataType="string" sortOrder="asc">
    </dxi-column>

    <dxi-column caption="Description" dataField="Report.Description" dataType="string">
    </dxi-column>

    <dxi-column caption="System" dataField="Report.IsSystem" dataType="boolean">
    </dxi-column>

    <dxi-column caption="Scheduled" [calculateCellValue]="isSchedulingEnabled" dataType="boolean">
    </dxi-column>

    <dxi-column caption="Send To" dataField="Report.SendTo" dataType="string">
    </dxi-column>

    <dxi-column caption="Start" [calculateCellValue]="schedulingStart" dataType="date" [format]="dateTimeService.getDevExpressDateTimeFunction">
    </dxi-column>

    <dxi-column caption="End" [calculateCellValue]="schedulingEnd" dataType="date" [format]="dateTimeService.getDevExpressDateTimeFunction">
    </dxi-column>

    <dxi-column biz-grid-user dataField="Report.CreatedBy" caption="Created By" [visible]="false">
        <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(reports, 'CreatedBy'))"></dxo-header-filter>
    </dxi-column>
    <dxi-column biz-grid-date dataField="Report.CreatedDate" caption="Created Date" [visible]="false" format="dateTime"></dxi-column>
    <dxi-column biz-grid-user dataField="Report.UpdatedBy" caption="Modified By" [visible]="false">
        <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(reports, 'UpdatedBy'))"></dxo-header-filter>
    </dxi-column>
    <dxi-column biz-grid-date dataField="Report.UpdatedDate" caption="Modified Date" [visible]="false" format="dateTime"></dxi-column>

    <dxi-column type="buttons">
        <dxi-button name="edit" [onClick]="editItem"></dxi-button>
        <dxi-button name="delete" [visible]="userReport"></dxi-button>
        <dxi-button text="Run" [onClick]="runItem"></dxi-button>
        <dxi-button text="Show Log" template="logTemplate" [visible]="allowShowLog"></dxi-button>
    </dxi-column>

    <ng-container *dxTemplate="let cell of 'logTemplate'">
        <app-change-log-link class="withNbsp" [title]="'Log for ' + cell.data.Report.Name" [showIcon]="false" classNames="dx-link">
            <app-change-log-link-entity type="Report" [id]="cell.data.Report.Id"></app-change-log-link-entity>
        </app-change-log-link>
    </ng-container>

</dx-data-grid>
